
import { defineComponent } from "vue";
import DrawerColumn from "@/components/drawers/bottom/DrawerColumn.vue";
import { mapState } from "pinia";
import { useLayout } from "@/services";

export default defineComponent({
  name: "DrawerColumns",
  components: {
    DrawerColumn,
  },
  props: {
    columns: {
      type: Number,
      default: 3,
    },
    bgVariant: {
      type: String,
      default: "",
    },
    titles: {
      type: Array as () => string[],
      default: () => [],
    },
    subTitles: {
      type: Array as () => string[],
      default: () => [],
    },
  },
  data: () => ({
    w: 0 as number,
    columnClasses: "col dc h-100 ",
  }),
  computed: {
    ...mapState(useLayout, [
      "bottomActiveTab",
      "isRightSidebarOpen",
      "isLeftSidebarOpen",
    ]),
  },
  watch: {
    bottomActiveTab: {
      handler() {
        this.updateSize();
      },
      immediate: true,
    },
    isRightSidebarOpen: {
      handler() {
        setTimeout(() => this.updateSize(), 400);
      },
    },
    isLeftSidebarOpen: {
      handler() {
        setTimeout(() => this.updateSize(), 400);
      },
    },
  },
  mounted() {
    this.$nextTick(this.updateSize);
    window.addEventListener("resize", this.updateSize);
  },
  methods: {
    updateSize() {
      this.w = this.$el instanceof HTMLDivElement ? this.$el.offsetWidth : 0;
    },
  },
});
